import { render, staticRenderFns } from "./UserEditPassword.vue?vue&type=template&id=2233800e&scoped=true"
import script from "./UserEditPassword.vue?vue&type=script&lang=js"
export * from "./UserEditPassword.vue?vue&type=script&lang=js"
import style0 from "./UserEditPassword.vue?vue&type=style&index=0&id=2233800e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233800e",
  null
  
)

export default component.exports